// extracted by mini-css-extract-plugin
module.exports = {"Centered":"PageLoader_Centered__2EuIo","Circle":"PageLoader_Circle__1oVSh","Car":"PageLoader_Car__1BHwU","Text":"PageLoader_Text__1d7wL"};